require("./grayscale");
var axios = require("axios");
var mtaInit = require("./mta");

$(function () {
    console.log($(".mta-info").data("api"));
    console.log($(".mta-info").data("appid"));
    console.log($(".mta-info").data("appkey"));
    mtaInit(
        $(".mta-info").data("api"),
        "388457604227138048",
        "D0FBD6A553174C9"
    );
});
$(function () {
    // if ($('.top-code').length > 0) {
    //     var qrcode = new QRCode(document.getElementsByClassName('top-code')[0], {
    //         width: 124,
    //         height: 124,
    //     })
    //     var url = $('.top-code').data('url')
    //     qrcode.makeCode(url)
    // }
    // 顶部导航子栏目控制
    $(".father-column").hover(function () {
        // $('#' + $(this).attr('id') + '-children-tab').css('display', 'block')
        // if ($(this).attr('id') == $('.children-column-box').attr('id')) {
        //     if ($('.children-column-box').css('display') == 'none') {
        //         $('.children-column-box').css('display', 'block')
        //     } else {
        //         $('.children-column-box').css('display', 'none')
        //     }
        // }
        // else {
        //     $('.children-column-box').attr('id', $(this).attr('id'))
        //     $('.children-column-box').css('display', 'block')
        // }
    });
    $(".top-tab-nav-item-tv").hover(
        function () {
            if ($(".top-tv").css("display") != "block") {
                $(".top-tv").slideDown("fast");
            }
        },
        function () {}
    );

    $(".top-tv").hover(
        function () {},
        function () {
            $(".top-tv").slideUp("fast");
        }
    );

    $(".top-tab-nav-item").hover(
        function () {
            if (!$(this).hasClass("top-tab-nav-item-tv")) {
                $(".top-tv").slideUp("fast");
            }
        },
        function () {}
    );
    $(".top-code").css("display", "none");
    var timer = null;
    $(".top-download-qr-btn").click(function () {
        console.log($(".top-code").css("display") == "block");

        if ($(".top-code").css("display") == "block") {
            $(".top-code").css("display", "none");
        } else {
            $(".top-code").css("display", "block");
        }
    });

    $(".top-user").hover(
        function () {
            $(".dropdown-list").show();
        },
        function () {
            setTimeout(function () {
                $(".dropdown-list").hide();
            }, 2000);
        }
    );

    $(".top-search-box-btn").click(function () {
        var keyword = $.trim($(".search-box-input").val());
        location.href = "/search?key=" + keyword;
    });

    $(".search-box-input").bind("keypress", function (event) {
        if (event.keyCode == "13") {
            var keyword = $.trim($(".search-box-input").val());
            location.href = "/search?key=" + keyword;
        }
    });
    $(".top-login-user").on("click", function () {
        // console.log(1111);
        // console.log($('.top-logout'));
        // console.log($('.top-logout').css('display'));
        if ($(".top-logout").css("display") == "block") {
            $(".top-logout").css("display", "none");
        } else {
            $(".top-logout").css("display", "block");
        }
    });
    $(".top-logout").on("click", function () {
        logout();
    });
    $("#nav-ltdj").on("click", function (e) {
        if ($(".top .top-login").length) {
            $(".top .top-login").click();
            return;
        }

        $.get(ROOT + "/party-building/web-url")
            .done(function (data) {
                var url = data.url;

                window.open(url, "_blank");
            })
            .fail(function (error) {
                alert(error.responseJSON.message);
            });
    });

    // window.onload = function () {
    //     changeSeachPos();
    // };
    // window.onresize = function () {
    //     changeSeachPos();
    // };
    //
    // function changeSeachPos() {
    //     // var top = $('.top-search').offset().top;
    //     var left = $('.top-search').offset().left;
    //
    //     // $('.top-search-box').css('top', top + 14);
    //     $('.top-search-box').css('left', left - 250);
    // }

    // window.onscroll = function () {
    //     var top = document.documentElement.scrollTop || document.body.scrollTop;
    //     if (top >= 72) {
    //         $('.top').height(62);
    //         $('.top-tab-nav-item').css('line-height', '62px');
    //         $('.top-tab-nav-item-tv').css('background-position-y', '30px');
    //     } else {
    //         $('.top').height(72);
    //         $('.top-tab-nav-item').css('line-height', '72px');
    //         $('.top-tab-nav-item-tv').css('background-position-y', '35px');
    //     }
    // };
});
